import React from "react";
import { Container, Row, Col } from "reactstrap";
import useGetData from "../custom-hooks/useGetData";
import { db } from "../firebase.config";
import { doc, deleteDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const AllProducts = () => {
	const { data: productsData, loading } = useGetData("products");

	const deleteProduct = async (id) => {
		await deleteDoc(doc(db, "products", id));
		toast.success("Deleted successfully!");
	};
	return (
		<section>
			<Container>
				<Row>
					<Col lg="12" className="d-flex justify-content-between">
						<h4 className="fw-bold">Products</h4>
						<Link
							to="/dashboard/add-product"
							className="btn btn-dark"
						>
							Add Product
						</Link>
					</Col>
					<Col lg="12" className="pt-5">
						<table className="table">
							<thead>
								<tr>
									<th>Image</th>
									<th>Product Name</th>
									<th>Category</th>
									<th>Price</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								{loading ? (
									<tr>
										<td>
											<h4 className="py-5 text-center fw-bold">
												loading......
											</h4>
										</td>
									</tr>
								) : (
									productsData.map((item) => (
										<tr key={item.id}>
											<td>
												<img
													src={item.imgUrl}
													alt={item.productName}
												/>
											</td>
											<td>{item.productName}</td>
											<td>{item.category}</td>
											<td>${item.price}</td>
											<td>
												<button className="btn btn-primary me-1">
													Update
												</button>
												<button
													onClick={() =>
														deleteProduct(item.id)
													}
													className="btn btn-danger"
												>
													Delete
												</button>
											</td>
										</tr>
									))
								)}
							</tbody>
						</table>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default AllProducts;
